import f3tch from 'f3tch';

import profile from '../../api/profiles/noData.profile.api';

export default (id) =>
  f3tch(`/branches/reduced_deductible_rates/${id}/`)
    .profile(profile())
    .delete();
